// Module
var code = "<form name=\"$ctrl.form.formRepre\" class=\"panel-body\"> <repre node=\"$ctrl.node\" ng-model=\"$ctrl.submission.krepre\" form=\"$ctrl.form.formRepre\" ng-disabled=\"$ctrl.disabled\" repre-add=\"!$ctrl.disabled\"></repre> </form> ";
// Exports
export default code;